module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$root.isOffline) ? _c('section', {
    staticClass: "small-section"
  }, [_c('h2', [_vm._v("Profile Details")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("First Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.first_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Last Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.last_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.username))])])])]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "change-password",
      "action": _vm.changePasswordUrl
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changePassword($event)
      }
    }
  }, [_c('FormGroup', {
    attrs: {
      "label": "Old Password",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password"
    }
  })]), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "New Password",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "new-password"
    }
  })]), _vm._v(" "), _c('FormGroup', {
    attrs: {
      "label": "Confirm Password",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "confirm-password"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Change Password")])], 1)]) : _c('page-offline-alert')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c558c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyProfile.vue
// module id = 277
// module chunks = 0